import { BaseWebComponentRepository } from '../../../../framework/BaseWebComponentRepository';
import { TagDetailsFormDataProviderFactory } from '../factory/TagDetailsFormDataProviderFactory';
import { TagDetailsFormBaseDataProvider } from '../dataProvider/TagDetailsFormBaseDataProvider';
import { TagDetailsFormViewData } from '../types/TagDetailsFormViewData';

export class TagDetailsFormRepository extends BaseWebComponentRepository {
  public dataProviderFactory: TagDetailsFormDataProviderFactory;
  public dataProvider: TagDetailsFormBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new TagDetailsFormDataProviderFactory(),
    });
  }

  async getDataForView(): Promise<TagDetailsFormViewData> {
    return this.dataProvider.getDataForView();
  }
}
